import { c as _c } from "react/compiler-runtime";
import { AutoCompleteInput } from "@website/accommodation-ui/tour-search-wrapper-group/tour-search-panel/auto-complete-input/auto-complete-input";
import { CityType } from "@website/accommodation-ui/tour-search-wrapper-group/tour-search-panel/auto-complete-input/types";
import { useSubmit, useValidation } from "@website/accommodation-ui/tour-search-wrapper-group/tour-search-panel/hooks";
import { TourSearchPanelPropertiesType } from "@website/accommodation-ui/tour-search-wrapper-group/tour-search-panel/types";
import { MaterialIcon } from "@website/icons/material";
import { Button } from "@website/ui/button";
import { FC, useState } from "react";
export const TourSearchPanelGroup: FC<TourSearchPanelPropertiesType> = properties => {
  const $ = _c(26);
  const {
    cityFrom,
    cityTo,
    destinationSuggestions,
    originSuggestions,
    page,
    onClose
  } = properties;
  const [selectedOriginItem, setSelectedOriginItem] = useState(cityFrom as CityType);
  const [selectedDestinationItem, setSelectedDestinationItem] = useState(cityTo as CityType);
  let t0;
  if ($[0] !== selectedDestinationItem || $[1] !== selectedOriginItem) {
    t0 = {
      originItem: selectedOriginItem,
      destinationItem: selectedDestinationItem
    };
    $[0] = selectedDestinationItem;
    $[1] = selectedOriginItem;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const {
    errors,
    submitValidationCheck
  } = useValidation(t0);
  const isHomePage = process.env.NEXT_PUBLIC_APP_NAME === "homepage";
  const {
    onSubmitClick,
    submitText
  } = useSubmit(selectedDestinationItem, selectedOriginItem, cityTo as CityType, cityFrom as CityType, isHomePage, submitValidationCheck);
  let t1;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <MaterialIcon name="close" />;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== onClose) {
    t2 = <div className="hidden w-full justify-end px-3 md:flex"><Button StartIcon={t1} color="neutral" onClick={onClose} size="small" variant="text" /></div>;
    $[4] = onClose;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== destinationSuggestions) {
    t3 = destinationSuggestions ?? [];
    $[6] = destinationSuggestions;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== originSuggestions) {
    t4 = originSuggestions ?? [];
    $[8] = originSuggestions;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== cityFrom || $[11] !== cityTo || $[12] !== errors || $[13] !== t3 || $[14] !== t4) {
    t5 = <div className="flex flex-col gap-4 lg:grow lg:flex-row"><div className="lg:grow-[2] xl:grow-[3]"><AutoCompleteInput cityFromInitial={cityFrom} cityToInitial={cityTo} destinationSuggestions={t3} errors={errors} onChangeDestination={setSelectedDestinationItem} onChangeOrigin={setSelectedOriginItem} originSuggestions={t4} /></div></div>;
    $[10] = cityFrom;
    $[11] = cityTo;
    $[12] = errors;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  const t6 = `${page === "homepage" ? "static" : "absolute"} bottom-0 max-md:!h-12 lg:static`;
  let t7;
  if ($[16] !== onSubmitClick || $[17] !== submitText || $[18] !== t6) {
    t7 = <div className="relative grow lg:grow-0"><Button aria-label="search" className={t6} fullWidth={true} onClick={onSubmitClick} size="x-large">{submitText}</Button></div>;
    $[16] = onSubmitClick;
    $[17] = submitText;
    $[18] = t6;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] !== t5 || $[21] !== t7) {
    t8 = <div className="flex h-full flex-col gap-6 lg:flex-row xl:gap-4">{t5}{t7}</div>;
    $[20] = t5;
    $[21] = t7;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  let t9;
  if ($[23] !== t2 || $[24] !== t8) {
    t9 = <div className={`flex h-full flex-col gap-6 2xl:mx-auto 2xl:w-[1200px] ${isHomePage ? "max-w-full px-0 xl:px-0 2xl:px-0" : "px-6 xl:px-10 2xl:px-0"}`} id="tourSearchPanl">{t2}{t8}</div>;
    $[23] = t2;
    $[24] = t8;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  return t9;
};